<template>
  <StepComponent>
    <v-row>
      <v-col>
        <AccountIdCardContent />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="client.title"
          maxlength="120"
          label="Business Name"
          :rules="rules.businessOrNames"
          id="title"
          disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="firstNameField"
          maxlength="120"
          label="First Name"
          id="firstName"
          :rules="rules.businessOrFirstName"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="lastNameField"
          maxlength="120"
          id="lastName"
          label="Last Name"
          :rules="rules.businessOrLastName"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="user.username"
          v-if="user.is_copy_to"
          maxlength="120"
          label="Username"
          disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="user.copy_to.email"
          v-if="user.is_copy_to"
          maxlength="120"
          label="Email"
          disabled
        ></v-text-field>
      </v-col>
    </v-row>
  </StepComponent>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import StepComponent from "@/components/registration/AccountSetupSteps/StepComponent";
import AccountIdCardContent from "@/components/clients/account/AccountIdCardContent";
import { mapFields } from "vuex-map-fields";

export default {
  name: "AccountInformationStep",
  components: { StepComponent, AccountIdCardContent },
  computed: {
    ...mapGetters("clients", ["selectedClient"]),
    ...mapFields("auth", ["user"]),
    ...mapFields("clients", [
      "items[0].title",
      "client",
      "items[0].first_name",
      "items[0].last_name"
    ]),
    ...mapFields("copyTo", [
      "communication_types",
      "report_layouts",
      "copy_to_communication_types_selected",
      "copy_to_report_layouts_selected"
    ]),
    rules() {
      let componentRules = {};

      const businessOrName = field => {
        return () => {
          return (
            !!this.title ||
            !!field ||
            "Business Name or First/Last Name are required"
          );
        };
      };

      const businessOrNames = () => {
        return (
          !!this.title ||
          !!this.first_name ||
          !!this.last_name ||
          "Business Name or First/Last Name are required"
        );
      };

      const lettersOnly = value => {
        return /^[A-Za-z ]+$/.test(value || "") || "Only letters are allowed";
      };

      // Apply the rules
      componentRules.businessOrNames = [businessOrNames];
      componentRules.businessOrFirstName = [
        businessOrName(this.first_name),
        lettersOnly
      ];
      componentRules.businessOrLastName = [
        businessOrName(this.last_name),
        lettersOnly
      ];
      componentRules.title = [lettersOnly];

      return componentRules;
    },
    titleField: {
      get() {
        return this.user.is_copy_to
          ? this.user.copy_to && this.user.copy_to.business_name
            ? this.user.copy_to.business_name
            : "N/A"
          : this.client.title;
      },
      set(val) {
        if (this.user.is_copy_to) {
          this.user.copy_to.business_name = val;
        } else {
          this.selectedClient.title = val;
        }
      }
    },
    firstNameField: {
      get() {
        return this.user.is_copy_to
          ? this.user.copy_to && this.user.copy_to.first_name
            ? this.user.copy_to.first_name
            : ""
          : this.client.first_name;
      },
      set(val) {
        if (this.user.is_copy_to) {
          this.user.copy_to.first_name = val;
        } else {
          this.selectedClient.first_name = val;
        }
      }
    },
    lastNameField: {
      get() {
        return this.user.is_copy_to
          ? this.user.copy_to && this.user.copy_to.last_name
            ? this.user.copy_to.last_name
            : ""
          : this.client.last_name;
      },
      set(val) {
        if (this.user.is_copy_to) {
          this.user.copy_to.last_name = val;
        } else {
          this.selectedClient.last_name = val;
        }
      }
    }
  },
  methods: {
    ...mapActions("clients", ["updateAccountInfo"]),
    ...mapActions("copyTo", ["updateCopyToReportingPreferences"]),
    ...mapActions("copyTo", ["getCopyToReportPreferences"]),
    ...mapActions("auth", ["getUser"]),
    beforeContinue() {
      if (!this.user.is_copy_to) {
        return this.updateAccountInfo().catch(e => {
          console.error(e);
          return false;
        });
      } else {
        return this.updateCopyToReportingPreferences({
          copy_to_id: this.user?.copy_to?.id,
          communication_types: this.communication_types_selected,
          report_layouts: this.report_layouts_selected,
          first_name: this.user.copy_to.first_name,
          last_name: this.user.copy_to.last_name
        })
          .then(success => {
            if (success) {
              this.getUser();
            }
            return success;
          })
          .catch(e => {
            console.error(e);
            return false;
          });
      }
    },
    resetValidation() {
      this.$emit("resetValidation");
    }
  },
  data() {
    return {
      communication_types_selected: [],
      report_layouts_selected: []
    };
  },
  mounted() {
    Promise.all([this.getCopyToReportPreferences()]).then(
      () => (this.loading = false)
    );

    this.communication_types_selected = this.user?.copy_to?.communication_types.map(
      c => c.id
    );
    this.report_layouts_selected = this.user?.copy_to?.report_layouts.map(
      r => r.id
    );
    this.client = this.selectedClient;
  }
};
</script>
